<app-modal-dialog 
[show]="showModal" 
size="lg" 
position="top"
(closed)="closedCreateNote()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Detalles de Nota de Ingreso</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>

    <div class="modal-body" modal-body>
        <div class="row mb-4 border rounded-1  py-2" *ngIf="entryNoteData != null">

            <!-- Proveeodr -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Proveedor</label>
                <p class="form-control-plaintext">{{ entryNoteData.providerData.name }}</p>
            </div>

            <!-- Codigo Proveedor -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Código Proveedor</label>
                <p class="form-control-plaintext">{{ entryNoteData.providerData.code }}</p>
            </div>

            <!-- Direccion -->
            <div class="col-sm-12 form-group mb-4">
                <label class="form-label font-bold">Dirección</label>
                <p class="form-control-plaintext">{{ entryNoteData.address }}</p>
            </div>

            <!-- NIT Proveeodr -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">NIT</label>
                <p class="form-control-plaintext">{{ entryNoteData.providerData.nit }}</p>
            </div>

            <!-- Fecha de ingreso -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Fecha de Ingreso</label>
                <p class="form-control-plaintext">{{ entryNoteData.entryDate | date:'yyyy-MM-dd' }}</p>
            </div>

            <!-- Descripción -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Transacción</label>
                <p class="form-control-plaintext">{{ entryNoteData.transactionDescription }}</p>
            </div>

            <!-- Ticket báscula -->
            <div class="col-sm-6 form-group mb-4">
                <label class="form-label font-bold">Boleta Báscula No.</label>
                <p class="form-control-plaintext">{{ entryNoteData.scaleTicketNumber }}</p>
            </div>

            </div>

            <!-- Tabla de productos -->
            <h6 class="font-semibold">Detalles de la Nota de Ingreso</h6>
            <div class="row py-2 px-0" *ngIf="entryNoteDetails.length > 0">
                <div class="col">
                    <div class="table-responsive table-bordered">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>Código</th>
                            <th class="text-right bg-warning-subtle">Cantidad</th>
                            <th class="td-center bg-info-subtle">Unidad/Item</th>
                            <th>Description</th>
                            <th class="text-right">Cantidad Recibida</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let detail of entryNoteDetails">
                            <td>{{ detail.productData.code }}</td>
                            <td class="text-right bg-warning-subtle">{{ detail.quantity }}</td>
                            <td class="td-center bg-info-subtle">{{ detail.item }}</td>
                            <td>{{ detail.productData.name }}</td>
                            <td class="text-right">{{ detail.quantityReceived }}</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>

            
            <div *ngIf="entryNoteDetails.length == 0" class="text-center text-danger border rounded-1">
                <span colspan="4">Esta nota no contiene detalles</span><i class="fa fa-info-circle ms-2"></i>
            </div>

            <div class="row mt-4 border rounded-1 py-2">

            <h6 class="font-semibold">Datos del Piloto</h6>
            <!-- Piloto -->
            <div class="col-sm-6 form-group mb-4" *ngIf="entryNoteData != null">
                <label class="form-label font-bold">Piloto</label>
                <p class="form-control-plaintext">{{ entryNoteData.pilotName? entryNoteData.pilotName : "" }}</p>
            </div>

            <!-- Placa cabezal -->
            <div class="col-sm-6 form-group mb-4" *ngIf="entryNoteData != null">
                <label class="form-label font-bold">Cabezal Placa</label>
                <p class="form-control-plaintext">{{ entryNoteData.headLicensePlate }}</p>
            </div>

            <!-- Placa cisterna -->
            <div class="col-sm-6 form-group mb-4" *ngIf="entryNoteData != null">
                <label class="form-label font-bold">Cisterna Placa</label>
                <p class="form-control-plaintext">{{ entryNoteData.tanketLicensePlate }} <br><span class="font-light text-sm italic">{{ entryNoteData.entryDate | date:'yyyy-MM-dd HH:mm' }}</span></p>
            </div>

            </div>
    </div>
</app-modal-dialog>